import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Loader } from 'src/components/loader';

export interface AuthHandoffScreenProps {
  message?: string;
}

export function AuthHandoffScreen({ message }: AuthHandoffScreenProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        px: 2,
        textAlign: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Loader size={64} />
      {message && (
        <Typography variant="h6" sx={{ color: 'text.secondary' }}>
          {message}
        </Typography>
      )}
    </Box>
  );
}
